import { Link } from 'react-router-dom';
import moment from 'moment';
import { Oval } from 'react-loader-spinner';

/**
 * ResearchAid report card for FreeDashboard "Prove Our Value" section.
 */
export default function ReportCard({ report, type, item, company, user, permissionLevel, onReportRedirect, onReportName, onDeleteHistoryRecord, isGenerateAllResearchAid }) {
	const creator = report?.['createdBy'];

	return (
		<div className="bo7 w100 keyfeature-wihte-item bg1 new-shadow br15px p1-5rem mx1rem my1-5rem pr bsbb">
			<div className="ttc fs1rem fw500 c15 lh2 zi1 w100">
				<div className="cp w100 h100" style={{ minHeight: '130px' }}>
					<div className="w100 df aic">
						<i className="icon-diligenstia mr1rem">
							<img className="br5px w50px" src={require('../../../../../images/checklist-logo.png')} alt="" />
						</i>
						<div className="df fdc mr1rem">
							<p className="w100 tal" style={{ color: '#929090', fontSize: '11px' }}>
								Research<span className="c4">Aid</span>
							</p>
							{report?.['htmlReport'] ? (
								<Link
									to={permissionLevel !== 'DASHBOARD' ? `#${report['_id']}?${report['reportType']}-researchaid` : '#'}
									onClick={() => onReportRedirect(report)}
									className="w100 fs1rem c15"
								>
									{report['name']}
								</Link>
							) : report['reportType'] === 'swotAnalysis' ? (
								<button type="button" onClick={() => onReportName(report)} className="cp w100 bg1 fs1rem tal c15">
									{report['name']}
								</button>
							) : (
								<Link to={`/researchAid/${company['_id']}?${report['reportType']}`} state={{ company }} className="w100 fs1rem c15">
									{report['name']}
								</Link>
							)}
						</div>
						{(report?.['htmlReport'] && company['subscription'] === 'Pro' && user['role'] !== 'Advisor' && user['role'] !== 'Investor') && (
							<>
								<Link to={`/researchAid/${company['_id']}#${report['_id'] || ''}?${report['reportType']}`} state={{ company }}>
									<i className="cp fa fa-edit pl1rem c3" style={{ fontSize: '20px', fontWeight: '400' }} />
								</Link>
								{report?.['history']?.length > 0 && (
									<div className="cp module-tooltip-box">
										<div className="hover-list" style={{ position: 'relative', left: 'auto', top: 'auto' }}>
											<i className="cp fa fa-history pl1rem c4" style={{ fontSize: '20px', fontWeight: '400' }} />
										</div>
										<span className="tooltip-area tooltip-reaserchaid">
											{report['history'].map((data) => (
												<div key={data['_id']} className="overlay-box" style={{ padding: '5px 10px' }}>
													<div className="df aic w100">
														{data?.['userId'] && (
															<span
																data-tooltip={`${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`}
																className="shadow w2rem h2rem bg16 bw3px bss bo19 df jcc aic br100 c1 mr0-5rem"
															>
																{data['userId']['profile'] ? (
																	<img
																		src={data['userId']['profile']}
																		className="new-shadow w30px h30px df jcc aic br100 bg16 c1"
																		alt=""
																		data-tooltip={`${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`}
																	/>
																) : (
																	<span className="bg16 c15 br50px" data-tooltip={`${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`}>
																		{data['userId']?.firstName ? data['userId'].firstName[0] + (data['userId'].lastName?.[0] || '') : '?'}
																	</span>
																)}
															</span>
														)}
														<div className="text-box df aic jcsb w100">
															<p className="c15" style={{ fontSize: '10px' }}>
																{data['lastUpdatedTime'] && <span>{data['lastUpdatedTime']}</span>}
															</p>
															{onDeleteHistoryRecord && (
																<button type="button" onClick={() => onDeleteHistoryRecord(report['_id'], data['_id'], type)}>
																	<i className="fa fa-trash c9 cp" style={{ fontSize: '20px' }} />
																</button>
															)}
														</div>
													</div>
												</div>
											))}
										</span>
									</div>
								)}
							</>
						)}
					</div>
					<div className="w100 df jcsb mt3rem px1rem">
						{!report?.['htmlReport'] && !report?.['score'] && !(report?.['reportType'] === 'swotAnalysis' && report?.['disableSwotReport']) ? (
							<>
								{isGenerateAllResearchAid && (
									<button type="button" className="cna br25px px3rem cp bg16 py0-5rem">
										<Oval height="20" width="20" strokeWidth="4" secondaryColor="#f9f9f9" color="#000" ariaLabel="oval-loading" />
									</button>
								)}
							</>
						) : (
							// A generated report (SWOT included) always carries htmlReport/score/createdAt. Show the
							// date + score whenever it is generated — don't hard-require a populated creator, otherwise
							// a report whose createdBy isn't populated (e.g. SWOT) renders a blank card body.
							(report?.['htmlReport'] || report?.['score']) && (
								<>
									{company['subscription'] === 'Free' ? (
										<div className="df fdc mt1rem">
											<p className="w100 fs0-75rem fw300">Executive Summary only.</p>
											<p className="w100 fs0-75rem fw300">
												To <span className="c7 fw500">UNLOCK</span> upgrade to PRO/LITE
											</p>
										</div>
									) : (
										<div className="df jcsb aic">
											{creator && (
												<span
													data-tooltip={`${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`}
													className="shadow w40px h40px bg16 bw3px bss bo19 df jcc aic br100 c1"
												>
													{creator?.profile ? (
														<img
															src={creator.profile}
															className="new-shadow w30px h30px df jcc aic br100 bg16 c1"
															alt=""
															data-tooltip={`${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`}
														/>
													) : (
														<span className="bg16 c15 br50px" data-tooltip={`${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`}>
															{creator?.firstName ? creator.firstName[0] + (creator.lastName?.[0] || '') : '?'}
														</span>
													)}
												</span>
											)}
											<p className="fs0-75rem c15 ml0-5rem">{moment(report.createdAt).format('ll')}</p>
										</div>
									)}
									<div className="df fdc">
										<p className={`fs1-5rem tac ${report?.['score'] >= 4 ? 'c34' : report?.['score'] >= 2 ? 'c39' : 'c4'}`}>
											{report?.['score']}
											<span className="fs0-75rem">/5</span>
										</p>
										<p className="fs0-75rem fw400 c15">
											Report <br /> Score
										</p>
									</div>
								</>
							)
						)}

						{item?.['time'] && !report?.['score'] && (
							<div className="df aic pa" style={{ right: '10px', bottom: '10px' }}>
								<img src={require('../../../../../images/dashboard/stopwatch.svg')} style={{ width: '14px', height: '14px' }} alt="" />
								<span style={{ fontSize: '14px' }}>{item?.['time']}</span>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
